import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'search-product_carousel_brand-click';

/**
 * This tracks the clicks of the brand from the carousel of products from the brand 
1. Source location of the click
2. Request ID 
3. Brand token
 */
export function trackSearchProductCarouselBrandClick(
  customParameterToken: string,
  customParameterToken2: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, customParameterToken2, brandToken },
  });
}
